import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './main-component/App/App.jsx'
import { ParallaxProvider } from 'react-scroll-parallax'
import 'bootstrap/dist/css/bootstrap.min.css'
// Font Awesome loaded from CDN in index.html
import './css/themify-icons.css'
import './css/animate.css'
import './css/flaticon_medically.css'
import '@flaticon/flaticon-uicons/css/regular/all.css'
import './sass/style.scss'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ParallaxProvider>
      <App />
    </ParallaxProvider>
  </React.StrictMode>
)
